import React from 'react'
import { Text } from '@/components/catalyst-ui/text'
import { ShieldCheckIcon } from '@heroicons/react/24/solid'

/**
 * Reusable Payment Summary Component
 * @param {Object} props
 * @param {Array} props.items - Array of {label: string, price: number|string} objects
 * @param {number} props.total - Total amount
 * @param {boolean} props.showPerYear - Whether to show "/year" suffix on total
 */
export default function PaymentSummary({ items = [], total = 0, showPerYear = false }) {
  return (
    <div className="sm:w-[512px] mt-0 ">
      <div className="bg-[#F4F4F5] p-3 rounded-t-lg flex flex-col shadow-[0px_4px_6px_-1px_#0000001A,0px_8px_4px_1px_#0000001A]">
        <div className="flex-1">
          <Text className="!font-medium !text-[#A1A1AA] mb-3 !text-sm">Summary</Text>
          <div className="space-y-2">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <hr className="border-gray-300" />
                <div className="flex justify-between items-center py-1">
                  <Text className="!text-sm !text-[#71717A] !font-medium">{item.label}</Text>
                  <Text className="!text-sm !text-[#09090B] !font-medium">${typeof item.price === 'number' ? item.price.toFixed(2) : item.price}</Text>
                </div>
              </React.Fragment>
            ))}
            <hr className="border-gray-300" />
            <div className="flex justify-between items-center">
              <Text className="!text-sm !text-[#71717A] !font-medium">Total:</Text>
              <Text className="!text-sm !text-[#09090B] !font-semibold">
                ${typeof total === 'number' ? total.toFixed(2) : total}{showPerYear ? '/year' : ''}
              </Text>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center gap-1 !text-xs !text-[#71717A] font-medium pt-2">
          <ShieldCheckIcon className="w-4 h-4 !text-[#047857]" />
          <span>Safe and secure payment</span>
        </div>
      </div>

      {/* Frill pattern */}
      <div className="relative w-full -mb-4">
        <svg 
          className="w-full h-6 block"
          viewBox="0 0 512 24" 
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern id="frill-pattern" x="0" y="0" width="12" height="24" patternUnits="userSpaceOnUse">
              <path 
                d="M 0,0 L 12,0 L 12,12 A 6,10 0 0,0 0,12 Z" 
                fill="#F4F4F5"
              />
            </pattern>
            <pattern id="frill-shadow-pattern" x="0" y="0" width="12" height="24" patternUnits="userSpaceOnUse">
              <path 
                d="M 0,12 A 6,6 0 0,0 12,12 L 12,14 A 6,10 0 0,1 0,14 Z" 
                fill="rgba(0,0,0,0.15)"
              />
            </pattern>
            <filter id="shadow-blur" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceGraphic" stdDeviation="1.2"/>
            </filter>
          </defs>
          <rect 
            width="100%" 
            height="24" 
            fill="url(#frill-pattern)"
          />
          <rect 
            width="100%" 
            height="6" 
            y="24"
            fill="url(#frill-shadow-pattern)"
            filter="url(#shadow-blur)"
            opacity="0.7"
          />
        </svg>
      </div>
    </div>
  )
}

